<div class="inline-table">
  <div class="inline-table__header">
    <label>{{ label }}</label>
    <button *ngIf="isEditModeActive" (click)="openAddModal()">
      {{ field.table_config?.addButtonText || 'Add Item' }}
    </button>
  </div>

  <table *ngIf="tableData?.length; else emptyState">
    <tr>
      <th *ngFor="let column of field.table_config?.columns">{{ column.title }}</th>
      <th *ngIf="isEditModeActive" colspan="2">Actions</th>
    </tr>
    <tr *ngFor="let row of tableData; let i = index">
      <td *ngFor="let column of field.table_config?.columns">
        {{ formatValue(row[column.name!], column) }}
      </td>
      <td *ngIf="isEditModeActive">
        <button (click)="editRow(i)">Edit</button>
        <button (click)="deleteRow(i)">Delete</button>
      </td>
    </tr>
  </table>

  <ng-template #emptyState>
    <div class="inline-table__empty">
      <p>No rows defined</p>
    </div>
  </ng-template>
</div>

<app-modal *ngIf="isModalOpen" (close)="closeModal()">
  <h2>{{ isEditing ? 'Edit' : 'Add' }} Item</h2>
  <form [formGroup]="modalForm">
    <div *ngFor="let column of field.table_config?.columns">
      <app-transforming-input
        [controlName]="column.name!"
        [form]="modalForm"
        [label]="column.title!"
        [type]="getInputType(column.kind)"
        [selectOptions]="column.dropdown_options"
        [autocompleteType]="column.autocomplete"
        [isEditModeActive]="true"
      ></app-transforming-input>
    </div>
  </form>
  <div class="modal-actions">
    <button (click)="closeModal()">Cancel</button>
    <button (click)="saveRow()">Save</button>
  </div>
</app-modal>
